/**
 * Atributos del EAV que **no son el lugar donde vive su dato**, o que ya se muestran en
 * otro lado de la pantalla. Los comparten la ficha y el formulario: si uno los escondiera
 * y el otro no, el operador vería dos versiones del mismo producto.
 *
 * Son de tres clases y conviene no mezclarlas:
 *
 * 1. **El dato vive fuera del EAV.** `category_ids` es `static` con backend model —en
 *    Magento es virtual y NUNCA tiene fila; la asignación está en
 *    `catalog_category_product`— y `quantity_and_stock_status` es el vestigio del stock,
 *    que vive en `cataloginventory_*`. Mostrarlos es mostrar un `—` permanente sobre un
 *    producto que sí tiene categoría y sí tiene stock.
 * 2. **Los gobierna otra máquina.** `status` y `vv_state` los mueve la máquina de estados,
 *    `url_key` y `url_path` nacen al publicar, y `visibility` es SALIDA del predicado de
 *    oferta —se escribe por store view, así que en scope default no hay fila ni la va a
 *    haber—. La ficha ya los muestra donde corresponde: la barra de estado.
 * 3. **Ya están en la cabecera.** `sku`, `name` y el dueño (`amrolepermissions_owner`, que
 *    es la primera participación y no un texto).
 *
 * Para el form la regla es además de seguridad: lo que entra acá no se manda en el
 * guardado, porque devolver `vv_state` reabría la venta de un producto pausado sin pasar
 * por el gate de Admin. El write path lo vuelve a filtrar del otro lado.
 */
export const ATRIBUTOS_DE_SISTEMA = new Set([
  // 3 · cabecera
  "sku",
  "name",
  "amrolepermissions_owner",
  // 2 · otra máquina
  "status",
  "vv_state",
  "visibility",
  "url_key",
  "url_path",
  // 1 · el dato vive fuera del EAV
  "category_ids",
  "quantity_and_stock_status",
  // De sistema, sin lector
  "old_id",
]);

/**
 * Los que **no viajan en el guardado**. Es la lista de arriba **menos `sku` y `name`**, y
 * esa resta es la razón de que sean dos constantes y no una:
 *
 * - `sku` y `name` están escondidos de las secciones porque se editan en el bloque de
 *   identidad, arriba — pero se editan, así que el payload los lleva. `sku` va como campo
 *   propio; `name` va adentro de `values`, que es donde el write path lo espera.
 * - El resto no se edita en ningún lado, y mandarlos es lo que abría la segunda puerta a
 *   la máquina de estados.
 *
 * Colapsar las dos en una sola lista **rompe el renombrado**, en silencio: el guardado sale
 * igual, la versión pendiente se crea igual, y el nombre nuevo no está en ninguna parte.
 */
export const NO_VIAJAN_EN_EL_GUARDADO = new Set(
  [...ATRIBUTOS_DE_SISTEMA].filter((code) => code !== "sku" && code !== "name"),
);
